<template lang="html">
  <div class="bg" v-if="show">
    <div class="imgEditor">
      <div class="headline">
        <p class="title">上传水印</p>
        <img src="@assets/img/common/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="content">
        <img :src="originImg" alt="" class="origin">
      </div>
      <div class="tools">
        <div class="left">
          <p class="f">移动</p>
          <p class="f r">重置</p>
        </div>
        <div class="right">
          <p class="f r">
            <img src="@assets/img/common/turnLeft.svg" alt="left">
          </p>
          <p class="f r">
            <img src="@assets/img/common/turnRight.svg" alt="right">
          </p>
          <p class="f r">
            <img src="@assets/img/common/cut.svg" alt="cut">
          </p>
          <p class="f r">
            <img src="@assets/img/common/bigger.svg" alt="big">
          </p>
          <p class="f r">
            <img src="@assets/img/common/smaller.svg" alt="small">
          </p>
          <div class="choose">
            <div class="frame">
              <span>
                选择水印
              </span>
              <img :src="showMarks?icons.up:icons.down" alt="icon" @click="toggleMarks()">
              <div class="marks" v-show="showMarks">
                
              </div>
            </div>
            <p class="trigger">添加</p>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="btn g">确定</div>
        <div class="btn">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imgEditor',
  data() {
    return {
      show: true,
      showMarks: false,
      originImg: require('@assets/img/common/default.png'),
      watermarks: [],
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg')
      }
    }
  },
  methods: {
    close() {
      this.show = false
    },
    toggleMarks() {
      this.showMarks = !this.showMarks
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .bg {
    z-index: 11111;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .7);
    .imgEditor {
      width: 700px;
      height: 550px;
      border-radius: 4px;
      background-color: #f9f9f9;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      padding: 20px 30px;
      .headline {
        height: 34px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .title {
          font-size: 24px;
          font-weight: bold;
        }
        .close {
          cursor: pointer;
        }
      }
      .content {
        width: 100%;
        height: 360px;
        position: relative;
        overflow: hidden;
        .origin {
          width: 100%;
        }
      }
      .tools {
        height: 30px;
        margin: 10px 0 20px;
        display: flex;
        justify-content: space-between;
        .f {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #dcdcdc;
          border-radius: 2px;
          margin-right: 10px;
          cursor: pointer;
          font-size: 14px;
          color: @sub;
        }
        .r {
          background-color: rgba(185, 195, 195, .2);
        }
        .left {
          width: 110px;
          display: flex;
          .f {
            width: 50px;
          }
        }
        .right {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .f {
            width: 30px;
          }
          .choose {
            width: 170px;
            display: flex;
            border-radius: 2px;
            // overflow: hidden;
            .frame {
              width: 120px;
              border-top-left-radius: 2px;
              border-bottom-left-radius: 2px;
              justify-content: space-between;
              line-height: 30px;
              border: 1px solid #dcdcdc;
              border-right: 0;
              padding: 0 10px;
              font-size: 14px;
              color: @dateColor;
              position: relative;
              span, img {
                display: inline-block;
              }
              img {
                cursor: pointer;
              }
              span {
                width: 84px;
              }
              .marks {
                position: absolute;
                border-radius: 2px;
                width: 119px;
                left: 0;
                top: 34px;
                height: 100px;
                background-color: red;
              }
            }
            .trigger {
              width: 50px;
              background-color: @green;
              color: #fff;
              text-align: center;
              font-size: 14px;
              line-height: 30px;
              cursor: pointer;
              border-top-right-radius: 2px;
              border-bottom-right-radius: 2px;
            }
          }
        }
      }
      .btns {
        height: 40px;
        display: flex;
        justify-content: center;
        .btn {
          width: 120px;
          height: 40px;
          text-align: center;
          font-size: 14px;
          line-height: 40px;
          border-radius: 100px;
          background-color: @dateColor;
          color: #fff;
          cursor: pointer;
          &:hover {
            .btnHover;
          }
          &:active {
            .btnActive;
          }
        }
        .g {
          background-color: @green;
          margin-right: 20px;
        }
      }
    }
  }
</style>
